<li routerLinkActive="active">
  <a [routerLink]="[linksTo]" (click)="clickEvent.emit()">
    <i><img src="{{ icon }}" alt="" /></i>
    <span>{{ label }}</span>
    <span *ngIf="notifications > 0" class="badge">{{ notifications }}</span>
  </a>
  <div></div>
</li>
